export default {
	name: 'Convention.Volunteers.Assignment',
	path: 'convention/volunteers/slots/:id/assignment',
	meta: {
		auth: true
	}
}